import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { getQuizSessions } from '../services/api';
import { Trophy, Users, Clock } from 'lucide-react';

const QuizLobbyPage = () => {
  const { getToken } = useAuth();
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      const token = await getToken();
      const data = await getQuizSessions(token);
      setSessions(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const joinSession = (sessionId) => {
    navigate(`/quiz/${sessionId}`);
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleString();
  };

  if (loading) return <div className="text-center py-10 text-text-light">Loading quizzes...</div>;

  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-secondary mb-6">🎮 Quiz Arena</h1>
        {sessions.length === 0 ? (
          <p className="text-text-light">No active quiz sessions. Check back later!</p>
        ) : (
          <div className="grid gap-4">
            {sessions.map((session) => (
              <div key={session.id} className="bg-surface rounded-xl shadow-md p-5 border-l-4 border-primary">
                <h2 className="text-xl font-semibold text-text">{session.title}</h2>
                <div className="flex flex-wrap gap-4 mt-2 text-sm text-text-light">
                  <span className="flex items-center gap-1"><Trophy size={14} /> {session.status}</span>
                  <span className="flex items-center gap-1"><Users size={14} /> Join with friends</span>
                  <span className="flex items-center gap-1"><Clock size={14} /> Created {formatDate(session.created_at)}</span>
                </div>
                <button
                  onClick={() => joinSession(session.id)}
                  className="mt-3 bg-primary hover:bg-green-600 text-white px-4 py-2 rounded-lg transition"
                >
                  Join Room →
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuizLobbyPage;